export default __webpack_public_path__ + "static/media/closeButton.a7613a8a.svg";